export default __webpack_public_path__ + "static/media/gnosis2.2b5fd6dd.png";